import { post, postRequest, getRequest, deleteRequest } from '@/utils/axios'
// 查询翻页
export function getChinaPageList(query) {
  return getRequest('/china/getPage', query)
}

// 添加
export function addChina(query) {
  return post('/china/add', query)
}
// --根据ID查询
export function getById(id) {
  return getRequest('/china/getById/' + id, id)
}
// 编辑
export function editChina(query) {
  return post('/china/edit', query)
}
// --根据id删除
export function delChina(ids) {
  return deleteRequest('/china/delByIds/' + ids, ids)
}

export function getChina(query) {
  return getRequest('/china/getChina', query)
}

export function getPage(query) {
  return getRequest('/china/getPage', query)
}

// 修改
export function update(query) {
  return post('/china/update', query)
}

export function addn(query) {
  return post('/china/addn', query)
}




// WEBPACK FOOTER //
// ./src/api/china.js